import { type EntitiesBetCategories } from '../../../states/entities/betCategories';
import { type BetCategoryState } from '../../../states/entities/betCategories';
import { type BetCategoryId } from '../../../states/entities/betCategories';
import { type StateType } from '../../../states/index';
import { type Selector } from '../../../types/selectors';
import { getBetCategoryIdFromProps } from '../../_propsGetters_';
import { selectEntitiesState } from '../entitiesPrimary.selector';

const emptyObject = {};

export const selectEntitiesBetCategories: Selector<EntitiesBetCategories> = (state: StateType) =>
  selectEntitiesState(state).betCategories ?? emptyObject;

//#region state.entities.betCategories
type EntitiesBetCategoriesSelectorProps = {
  betCategoryId?: BetCategoryId;
};

export const selectEntitiesBetCategoriesEntity: Selector<BetCategoryState | undefined> = (
  state: StateType,
  props: EntitiesBetCategoriesSelectorProps = {},
) => {
  const betCategoryId = getBetCategoryIdFromProps(state, props);

  if (betCategoryId) {
    return selectEntitiesBetCategories(state)[betCategoryId];
  }
};
//#endregion

//#region state.entities.betCategories[betCategoryId]
export const selectEntitiesBetCategoriesEntityBetCategoryId: Selector<number | undefined> = (state: StateType, props) =>
  selectEntitiesBetCategoriesEntity(state, props)?.betCategoryId;

export const selectEntitiesBetCategoriesEntityName: Selector<string | undefined> = (state: StateType, props) =>
  selectEntitiesBetCategoriesEntity(state, props)?.name;

export const selectEntitiesBetCategoriesEntityDisplayOrder: Selector<number | undefined> = (state: StateType, props) =>
  selectEntitiesBetCategoriesEntity(state, props)?.displayOrder;
//#endregion
